export default {
  "content": "<path d=\"M17 8H9.415l9.793 9.793-1.414 1.414L8 9.414V17H6V7a1 1 0 011-1h10v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};